'use client'

import { InstructionSize } from '@/app/product/[slug]/_components/product-info-sizes/instructions-size'
import { getValue } from '@/lib/utils'
import { useProductDetailSafe } from '../../context/product-detail-context'
import { useProductDetailStore } from '../../hooks/use-product-detail-store'
import { ProductInfoVariantItem } from '../product-info/product-info-variant-item'
import { ProductInfoSizeItem } from './product-info-size-item'

type Props = {
  sizeChart: string
}

export const ProductInfoSizesCombo: React.FC<Props> = ({ sizeChart }) => {
  const { comboSelectedInfo, product } = useProductDetailSafe()
  const { isDisableComboSize, handleComboSizeChange } = useProductDetailStore()

  const combo = product?.combo?.options || []

  return (
    <>
      {combo?.map((item, optionIndex) => (
        <div key={item.title}>
          <div className='mb-2 flex items-baseline justify-between lg:py-0'>
            <span className='font-sans text-base leading-5 text-neutral-900'>
              {item.title}:
              <p className='ml-2 inline font-medium text-neutral-600'>
                {getValue(comboSelectedInfo, `option${optionIndex + 1}`, '')}
              </p>
            </span>
            {item?.option_id?.includes('size') && (
              <InstructionSize sizeChart={sizeChart} />
            )}
          </div>
          {item?.option_id?.includes('color') ? (
            <ul className='grid grid-cols-5 gap-2.5 gap-y-1.5 md:flex md:flex-wrap lg:gap-3 lg:gap-y-3'>
              {item.values.map((value) => {
                const isActive =
                  getValue(
                    comboSelectedInfo,
                    `option${optionIndex + 1}`,
                    ''
                  ) === value.value
                return (
                  <li className='col-span-1' key={value.value}>
                    <ProductInfoVariantItem
                      isActive={isActive}
                      onClick={() =>
                        handleComboSizeChange(value.value, optionIndex)
                      }
                      title={value.label}
                      imageUrl={value.image || ''}
                    />
                  </li>
                )
              })}
            </ul>
          ) : (
            <ul className='flex flex-wrap gap-2 gap-y-3'>
              {item.values.map((val) => (
                <ProductInfoSizeItem
                  key={val.value}
                  isActive={
                    getValue(
                      comboSelectedInfo,
                      `option${optionIndex + 1}`,
                      ''
                    ) === val.value
                  }
                  onClick={() => handleComboSizeChange(val.value, optionIndex)}
                  title={val.label}
                  isDisabled={isDisableComboSize(val.value, optionIndex)}
                />
              ))}
            </ul>
          )}
        </div>
      ))}
    </>
  )
}
